// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/weight-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/weight-limits/weight-limits.js';

mount([g0]);
